/**
 * Customer Notification API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { XpoConnectBillingServiceModelsV2PaymentPaymentSearchQueryRequest } from './xpoConnectBillingServiceModelsV2PaymentPaymentSearchQueryRequest';


export interface XpoConnectBillingServiceModelsV2PaymentPaymentSearchRequest { 
    filterRequest?: XpoConnectBillingServiceModelsV2PaymentPaymentSearchQueryRequest;
    pageNumber?: number | null;
    pageSize?: number | null;
}

